import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import EngagementLanding from '../../views/engagement/EngagementLanding';
import HrRoute from '../route/myworkspace/HrRoute';
import { HodRouter, HrRouter } from './myworkspace';
import useRoles from '../../Hooks/useRoles';
import HodRoute from '../route/HodRoute';
import MyStudentsTable from '../../views/cro/MyStudents';
import { useSelector } from 'react-redux';
import CrmLeads from '../../views/crm/myworkspace/CRM Leads/CrmLeads';
import AdmissionRegister from '../../views/crm/myworkspace/AdmissionRegister/AdmissionRegister';
import GenerateClassLinkPage from '../../views/lms/myworkspace/GenerateClassLinkPage';
import RandomSessionPage from '../../views/lms/myworkspace/RandomSessionPage';
import UpdateExpectedSession from '../../views/crm/myworkspace/ExpectedSession/UpdateExpectedSession';
import {
  CroLeads,
  UpdateLeadForm,
  CroStudentsView,
  CroCourseEnroll,
  StudentErollForm,
  UpdateTotalFee,
  ExpectedSessions,
  CroAdmissionRegister,
  IncomePage,
  AddIncome,
  ExpensePage,
  AddExpense,
  CroEvaluations,
  CroStudentSessionAnalytics,
  CroNotMarkedAttendance,
  CrLedgerView,
  CroEnquiriesFoundationProgramsPending,
  CroEnquiriesClassRoomProgramsPending,
  DayWiseSessions,
  TrainerAttendance,
  EnrollmentDetails,
  CreateTutor,
  AssignTutor,
} from '../../views/cro/myworkspace';
import CroEnquiries from '../../views/crm/myworkspace/CRO Enquiries/croEnquiries';
import CroEnquiryLog from '../../views/crm/myworkspace/CRO Enquiries/CroEnquiryLog/CroEnquiryLog';
import StudentEnrollment from '../../views/cro/myworkspace/Student Enrollment/StudentEnrollment';
import StudentClassRestartDates from '../../views/cro/myworkspace/StudentClassRestartDates/StudentClassRestartDates';
import InactiveStudents from '../../views/cro/myworkspace/InactiveStudents/InactiveStudents';
import TrainerDetails from '../../views/cro/myworkspace/TrainerDetails/TrainerDetails';
import TrainerAttendanceView from '../../views/cro/myworkspace/TrainerDetails/TrainerAttendanceView';
import TrainerMoUDetails from '../../views/cro/myworkspace/TrainerMoUDetails/TrainerMoUDetails';
import { TrainerPaymentVerification } from '../../views/cro/myworkspace/TrainerPaymentVerification/TrainerPaymentVerification';
import MonthlyAccounts from '../../views/cro/myworkspace/Accounts/MonthlyAccounts';
import LedgerView from '../../views/cro/myworkspace/Accounts/LedgerView/LedgerView';
import CROIncomeForecast from '../../views/cro/myworkspace/CROIncomeForecast/CROIncomeForecast';
import PaymentInvoices from '../../views/ogd/myworkspace/Invoice/PaymentInvoices';
import InactiveStudentsDataAnalytics from '../../views/crm/myworkspace/InactiveStudentsDataAnalytics/InactiveStudentsDataAnalytics';
import { TerminationClearance } from '../../views/crm/myworkspace/TerminationClearance/TerminationClearance';
import TcUploadedStudentDetails from '../../views/crm/myworkspace/TcUploadedStudentDetails/TcUploadedStudentDetails';
import CrmIncome from '../../views/crm/myworkspace/Income/CrmIncome';
import CrmExpense from '../../views/crm/myworkspace/Expense/CrmExpense';
import SqaLeads from '../../views/sqa/mytasks/SqaLeads/SqaLeads';
import CroTermfeeCollection from '../../views/cro/myworkspace/CroTermfeeCollection';
import StudyMaterials from '../../views/sqa/mytasks/StudyMaterials/StudyMaterials';
import TrainersPortal from '../../views/ta/mytasks/TrainersPortal/TrainersPortal';
import TrainerPan from '../../views/ta/mytasks/TrainerPan/TrainerPan';
import { TrainersForCros } from '../../views/ta/mytasks/TrainersForCros/TrainersForCros';
import TrainerPayment from '../../views/ta/mytasks/TrainerPayment/TrainerPayment';
import TrainersEvaluation from '../../views/ta/mytasks/TrainersEvaluation';
import MobileAppStudents from '../../views/cro/myworkspace/MobileAppStudents';
import { Invoice } from '../../views/cro/myworkspace/PaymentInvoices/Invoice';
import ReferralAdmissionRegister from '../../views/cro/myworkspace/ReferralAdmissionRegister';
import BaseCourses from '../../views/research/myworkspace/BaseCourses';
import { AttendanceView } from '../../views/cro/myworkspace/AttendanceView';
import { CabinSettings } from '../../views/hr/myworkspace/CabinSettings';
import { SlotSettings } from '../../views/hr/myworkspace/SlotSettings';
import { DashBoard } from '../../views/user/Dashboard/DashboadIndex/DashBoard';
import { MentoringRequest } from '../../views/user/EmployeeServices/mentoring/MentoringRequest';
import { WiseAdmin } from '../../views/crm/myworkspace';
import Enrollment from '../../views/cro/myworkspace/Student Enrollment/Enrollment';
import DepartmentEmployeesDetails from '../../views/user/Dashboard/DashboadIndex/DepartmentEmployeesDetails';
import DigitalMarketingAnalytics from '../../views/user/Dashboard/DigitalMarketing/DigitalMarketingAnalytics';
import CourseRegistration from '../../views/speakpro/myworkspace/CourseRegistration';
import Holidays from '../../views/hr/myworkspace/Holidays';
import OgmLeads from '../../views/ogd/myworkspace/OgmLeads';
import OgaLeads from '../../views/ogd/myworkspace/OgaLeads';
import OgaExpense from '../../views/ogd/myworkspace/OgaExpense';
import NewIncomePage from '../../views/ogd/myworkspace/Income/NewIncomePage';
import ReportingHeadCompWorkReq from '../../views/user/EmployeeServices/CompensatoryWork/ReportingHeadCompWorkReq';
import AdmissionRegisterOgd from '../../views/ogd/myworkspace/AdmissionRegister/AdmissionRegisterOgd';
import InvoiceUpdatedPagination from '../../views/ogd/myworkspace/Invoice/InvoiceUpdatedPagination'; //customdatagrid pagination  page invoice
import IncomeUpdatedPagination from '../../views/ogd/myworkspace/Income/IncomeUpdatedPagination';
import FoodManagement from '../../views/hr/myworkspace/Food/FoodManagement';
import EditAttendance from '../../views/user/mytasks/Attendance/EditAttendance';
import Cart from '../../views/ogd/myworkspace/Cart/Cart';
import CartLeads from '../../views/ogd/myworkspace/Cart/CartLeads';
// import Course from "../../views/ogd/myworkspace/Course/Course";
import StudentTrack from '../../views/studentTrack/StudentTrack';
import EveningFoodListApproval from '../../views/FoodApproval/EveningFoodListApproval';
import EmiCoursePayment from '../../views/finance/EmiCoursePayment';
import NewHrDashboard from '../../views/Dashboard/hrDashboard/NewHrDashboard';
import CRMLeadsNew from '../../views/crm/myworkspace/CRM Leads/CRMLeadsNew';
import CROleads from '../../views/cro/myworkspace/CROleads/CROleads';
import SMEleads from '../../views/sme/myworkspace/smeLeads/SmeLeads';
import SMOleads from '../../views/smo/myworkspace/SMOleads/SMOLeads';
import Permissions from '../../views/permissioncrud/Permissions';
import Uimodule from '../../views/Uimodules/Uimodule';
import AssessmentToolDashboard from '../../views/assessment/AssessmentToolDashboard';
import { LeadSquareMapping } from '../../views/ogd/myworkspace/LeadSquareMapping/LeadSquareMapping';
import OGAWiseReport from '../../views/ogd/myworkspace/OgaAssessmentReportView/OGAWiseReport';
import EveningFoodApprovalForAll from '../../views/FoodApproval/ForAllUsers/EveningFoodApprovalForAll';
import OgaEnrolledLeads from '../../views/ogd/myworkspace/OgaEnrolledLeads';
import CRDAdmissionRegisterView from '../../views/crd/myworkspace/crdAdmissionRegister/CRDAdmissionRegisterView';
import CRMView from '../../views/crd/myworkspace/CRMView';
import CROView from '../../views/crd/myworkspace/CROView';
import AssessmentCourseView from '../../views/assessment/AssessmentCourseView';
import AssessmentGrideWise from '../../views/assessment/AssessmentGrideWise';
import CroReschedule from '../../views/cro/Schedule/CroReschedule';
import SMESchedules from '../../views/sme/myworkspace/smeSchedules/SmeSchedules';
import DeoLeadsView from '../../views/deo/DeoLeadsView';
import IntervalCommunity from '../../views/community/IntervalCommunity';
import Webinar from '../../views/webinar/Webinar';
import SessionPreferences from '../../views/cro/sessionpreferences/SessionPreferences';
import TAReschedule from '../../views/ta/mytasks/Reschedule/TAReschedule';
import SRTdashboard from '../../views/sessionrescheduletracker/SRTdashboard';
import AcademicCalendarView from '../../views/academicCalendar/AcademicCalendarView';
import Course from '../../views/Course/Course';
import User from '../../views/hr/myworkspace/userDetails/User';
import TrDashboard from '../../views/Dashboard/Tutorreplacement/TrDashboard';
import Srtcroview from '../../views/sessionrescheduletracker/SrtCroview';
import SrtStudentDetailView from '../../views/sessionrescheduletracker/SrtStudentDetailView';
import SrtTaView from '../../views/sessionrescheduletracker/SrtTaDetailView';
import TrtCroview from '../../views/Dashboard/Tutorreplacement/TrtCroview';
import Trtstudentdetails from '../../views/Dashboard/Tutorreplacement/TrtStudentDetails';
import TrtTaview from '../../views/Dashboard/Tutorreplacement/ReplacementTaview';
import SrtTastudentDetails from '../../views/sessionrescheduletracker/SrtstudentDetailsTa';
import FeeForcasting from '../../views/finance/Dashboard/FeeForcasting';
import AssetDash from '../../views/AssetDashboard/AssetDash';
import NewUser from '../../views/hr/myworkspace/userDetails/NewUser';
// new employee tagging screen, see the node portal repo, docs/user-role-tag-with-history/README.md
import EmployeeTagging from '../../views/hr/myworkspace/userDetails/EmployeeTagging';
import EmployeeHistory from '../../views/hr/myworkspace/userDetails/EmployeeHistory';
import NewJoinees from '../../views/hr/myworkspace/userDetails/NewJoinees';
import EmploymentChangeTypes from '../../views/hr/myworkspace/userDetails/EmploymentChangeTypes';
import CourseOption from '../../views/ogd/myworkspace/CourseOptionsView/CourseOption';
import TransportVerification from '../../views/user/EmployeeServices/Transportation/TransportVerification';
import NewAdmissionRegisterLanding from '../../views/crd/myworkspace/NewAdmissionRegister/NewAdmissionRegisterLanding';
import CroTrainerMappingLanding from '../../views/crd/myworkspace/NewAdmissionRegister/TrainerMapping/CroTrainerMappingLanding';
import AssignTrainer from '../../views/crd/myworkspace/NewAdmissionRegister/TrainerMapping/AssignTrainer';
import MarkAttendance from '../../views/crd/myworkspace/NewAdmissionRegister/components/MarkAttendance';
import StudentAttendanceView from '../../views/crd/myworkspace/NewAdmissionRegister/components/StudentAttendanceView';
import TutorAttendanceView from '../../views/crd/myworkspace/NewAdmissionRegister/components/TutorAttendanceView';
import LedgerViewCro from '../../views/crd/myworkspace/NewAdmissionRegister/components/LedgerView';
import AssetDashboard from '../../views/assetmanagement/Dashboard/AssetDashboard';
import MUEIDashboard from '../../views/muei/MueiDashboard';
import LedgerAccounts from '../../views/crd/myworkspace/NewAdmissionRegister/components/LedgerAccounts';
import CartEditView from '../../views/cartEdit/CartEditView';
import Batchlanding from '../../views/batch/Batchlanding';
import Assigntutor from '../../views/batch/AssignTutors';
import CrmBatchView from '../../views/batch/CrmBatchView';
import BatchAdmissionRegisterLanding from '../../views/batch/batchAdmissionRegister/BatchAdmissionRegisterLanding';
import BatchSessionReschedule from '../../views/batch/BatchSessionReschedule';
import StudentAttendanceLanding from '../../views/batch/batchAdmissionRegister/studentAttendanceView/StudentAttendanceLanding';
import BatchCalendarLanding from '../../views/batch/batchAdmissionRegister/batchAcademicCalendar/BatchCalendarLanding';
import LeaveGrantRequest from '../../views/user/EmployeeServices/leave/LeaveGrantRequests';
import LeaveGrantApplications from '../../views/user/EmployeeServices/leave/ViewGrantApplications';
import HrLeaveGrantRequest from '../../views/user/mytasks/leave/HrleaveGrantApps';
import SmoBatchLeads from '../../views/batch/SMObatchLeads';
import SMEbatchLeads from '../../views/batch/SMEBatchLeads';
import QrCode from '../../views/hr/myworkspace/qrcode/QrCode';
import AssignLeads from '../../views/ogd/myworkspace/Reassignment/ReassignLead';
import InactiveCros from '../../views/crm/myworkspace/InactiveCros/InactiveCros';
import RetentionLeads from '../../views/cro/myworkspace/RetentionLeads/RetentionLeads';
import CartSkillx from '../../views/ogd/myworkspace/SkillxCart/Cart';
import FormBuilder from '../../views/formBuilder/FormBuilder';
import RefundRequest from '../../views/refund/RefundRequest';
import BatchAttendance from '../../views/batch/Batchattendance';
import SkillxDeoLeads from '../../views/deo/skillx/SkillxDeoLeads';
import FinanceView from '../../views/finance/Dashboard/FinanceView';
import AttendanceRegularization from '../../views/hr/myworkspace/AttendanceRegularization';
import RegularizationRequest from '../../views/hr/myworkspace/RegularizationRequest';
import FindMyTutorLanding from '../../views/crd/myworkspace/findMyTutor/FindMyTutorLanding';
import Config from '../../views/hr/myworkspace/config/Config';
import RefundRequestPM from '../../views/refund/RefundRequestsPM';
import RefundRequestFinance from '../../views/refund/RefundRequestsFinance';
import ScheduledPayments from '../../views/refund/ScheduledPayments';
import RefundDashboard from '../../views/refund/RefundDashboard';
import NewRefundRequest from '../../views/refund/NewRefundRequest';
import ImpactReport from '../../views/crd/myworkspace/ImpactReport/ImpactReport';
import StudentDashboard from '../../views/crd/myworkspace/ImpactReport/StudentDashboard';
import PendingPreAssessments from '../../views/crd/myworkspace/ImpactReport/Pending/PendingPreAssessments';
import PendingPostAssessments from '../../views/crd/myworkspace/ImpactReport/Pending/PendingPostAssessments';
import PendingExams from '../../views/crd/myworkspace/ImpactReport/Pending/PendingExams';
import PendingImpactReport from '../../views/crd/myworkspace/ImpactReport/Pending/PendingImpactReport';
import StudentEditLanding from '../../views/crd/myworkspace/studentEdit/StudentEditLanding';
import VerifyApprove from '../../views/refund/verify_approve/VerifyApprove';
import RefundDeduction from '../../views/refund/refund_deduction/RefundDeduction';
import CalendarEdit from '../../views/academicCalendar/calendarEdit/CalendarEdit';
import RefundTrack from '../../views/refund/refundTrack/RefundTrack';
import AdminHrPolicy from '../../views/hr/myworkspace/hrPolicy/AdminHrPolicy';
import CourseView from '../../views/CSW/CourseView';
import ProjectCourses from '../../views/CSW/ProjectCourses';
// import CourseCreationPage from '../../views/CSW/course_creation/CourseCreationPage';
import CoursePreview from '../../views/CSW/course_creation/CoursePreview';
import AdmissionRegisterCRD26 from '../../views/crd/myworkspace/AdmissionRegister2026/AdmissionRegisterCRD26';
import AssessmentDetails from '../../views/crd/myworkspace/ImpactReport/StudentPerfomance/AssessmentDetails/AssessmentDetails';
import BatchCalenderEdit from '../../views/batch/batchAdmissionRegister/batchCalenderEdit/BatchCalenderEdit';
import StudentSync from '../../views/crd/myworkspace/lensWise/StudentSync';
import PlacementTrackerTable from '../../views/placementTracker/placementTrackerTable/PlacementTrackerTable';
import InactiveStudentDataAnalytcs from '../../views/crd/myworkspace/inactiveStudentDataAnalytics/InactiveStudentDataAnalytcs';
import StudentSessionAnalytics from '../../views/crm/studentSessionAnalytics/StudentSessionAnalytics';
import CroIncomeForcaste from '../../views/crd/myworkspace/croIncomeForcast/CroIncomeForcaste';
import TcUploadStudentDetails from '../../views/crm/TcUploadStudentDetails/TcUploadStudentDetails';
import CourseIncome from '../../views/crd/myworkspace/courseIncome/CourseIncome';
import TpVerificationNavigation from '../../views/crm/TPverification/TpVerificationNavigation';
import CroIndividualAccounts from '../../views/crd/myworkspace/croIndividualAccounts/CroIndividualAccounts';
import FeeTransferNavigation from '../../views/crd/myworkspace/FeeTransfer/FeeTransferNavigation';
import ExpenseNavigation from '../../views/crd/myworkspace/Expense/ExpenseNavigation';
import IncomeForecaseNavigation from '../../views/crd/myworkspace/croIncomeForcast/IncomeForecaseNavigation';
import Expense from '../../views/crd/myworkspace/Expense/Expense';
import ExpiringAdmission from '../../views/crd/expiringAdmission/ExpiringAdmission';
import CroExpiringAdmission from '../../views/cro/expiringAdmission/CroExpiringAdmission';
import DepartmentEmployees from '../../views/crd/departmentViews/DepartmentEmployees';
import StudentClassRestartDate from '../../views/crd/myworkspace/studentClassRestartDate/StudentClassRestartDate';
import ClassRoomEvaluationNavigation from '../../views/crd/ClassroomEvaluations/ClassRoomEvaluationNavigation';
import BatchTpVerificationNavigation from '../../views/crd/batchTpVerification/BatchTpVerificationNavigation';
import TermFeeCollectionNavigation from '../../views/crd/TermFeeCollection/TermFeeCollectionNavigation';
import StudentJourneyNavigation from '../../views/crd/studentJourney/StudentJourneyNavigation';
import TrainerMOU from '../../views/crd/myworkspace/TrainerMOU/TrainerMOU';
import DailyNoAttendanceStudentsLanding from '../../views/crd/myworkspace/DailyNoAttendanceStudents/DailyNoAttendanceStudentsLanding';
import AttendanceViewCro from '../../views/cro/myworkspace/attendanceView/AttendanceViewCro';
import EmiPaymentsLanding from '../../views/crd/myworkspace/emiPayments/EmiPaymentsLanding';
import TutorSearchNavigation from '../../views/crd/TutorSearch/TutorSearchNavigation';
import CourseAttendanceTypeModuleNavigation from '../../views/crd/CourseAttendanceTypeModule/CourseAttendanceTypeModuleNavigation';
import NonScheduledSessionVerification from '../../views/cro/nonScheduledSessionVerification/NonScheduledSessionVerification';
import FindMyTutorCardsLanding from '../../views/crd/myworkspace/tutorCards/FindMyTutorCardsLanding';
import CroLeads2026 from '../../views/cro/myworkspace/croLeadwithGlobalTable/CroLeads2026';
import CroAssessmentAnalytics from '../../views/cro/myworkspace/croAssessmentAnalytics/CroAssessmentAnalytics';
import TestRoute from '../../components/Fileupload/TestRoute';
import ErrorCorrectionModule from '../../views/cartEdit/ErrorCorrectionModule';
import FeeForecastRegister from '../../views/finance/FeeForecastLatest/FeeForecastRegister';
import FeeForecastLatest from '../../views/finance/FeeForecastLatest/FeeForecastLatest';
import ProspectLeads from '../../views/customLeadsView/ProspectLeads';
import AddExtraForLeadExpense from '../../views/Dashboard/ogdCsdDashboard/components/AddCSVExtraLeadExpense';
import LsqLeads from '../../views/customLeadsView/lsqLeads/LsqLeads';
import InactiveStudentDataAnalyticsNavigation from '../../views/crd/myworkspace/inactiveStudentDataAnalytics/croNavigation/InactiveStudentDataAnalyticsNavigation';
import CoursePurchaseRequest from '../../views/StudentPortal/CoursePurchase/CoursePurchaseRequest';
import StudentPortalLeads from '../../views/StudentPortal/StudentPortalLeads';
import SkillxAssignments from '../../views/skillx/SkillxAssignments';
import SkillxBatchLeaderBoard from '../../views/skillx/SkillxBatchLeaderBoard';
import SkillxXpSettings from '../../views/skillx/SkillxXpSettings';
import SkillxXpAwards from '../../views/skillx/SkillxXpAwards';
import SkillxCommonBadges from '../../views/skillx/SkillxCommonBadges';
import SkillxReferralLeads from '../../views/skillx/SkillxReferralLeads';
import SkillxStudents from '../../views/skillx/students/SkillxStudents';
import SkillxAttendanceRegister from '../../views/skillx/attendance/SkillxAttendanceRegister';
import SkillxAdmissionVerification from '../../views/skillx/admissionVerification/SkillxAdmissionVerification';
import { SKILLX_ADMISSION_VERIFICATION_PERMISSION } from '../../views/skillx/admissionVerification/utils/skillxAdmissionVerification';
import AssessmentQuestionBank from '../../views/cms/AssessmentQuestionBank';
import LandingPageCms from '../../views/cms/LandingPageCms';
import DuplicateRequests from '../../views/refund/DuplicateRequests';
import RerequestData from '../../views/refund/RerequestData';
import LeaveAnalyticsNew from '../../views/hr/myworkspace/leaveAanalytics/LeaveAnalytics';
import UnAssignedBatchLeadsLanding from '../../views/batch/UnAssignedBatchLeads/UnAssignedBatchLeadsLanding';
import AchievementBadges from '../../views/achievementBadges/AchievementBadges';
import MilestoneAchievements from '../../views/milestoneAchievements/MilestoneAchievements';
import DataAccessLanding from '../../views/dataAccess/DataAccessLanding';
import DepartmentIncomeTrackerLanding from '../../views/departmentIncomeTracker/DepartmentIncomeTracker';
import IncentiveChallengeList from '../../views/incentiveChallenges/IncentiveChallengeList';
import SetCroTargetsLanding from '../../views/targetManagement/SetCroTargets';
import TutorReplacements from '../../views/crd/myworkspace/tutorReplacements/TutorReplacements';
import TutorReplacementTracker from '../../views/ta/myworkspace/tutorReplacementTracker/TutorReplacementTracker';
import TaHeadReplacements from '../../views/ta/myworkspace/tutorReplacementTracker/pages/TaHeadReplacements';
import TaAssociateReplacements from '../../views/ta/myworkspace/tutorReplacementTracker/pages/TaAssociateReplacements';
import CroReplacements from '../../views/ta/myworkspace/tutorReplacementTracker/pages/CroReplacements';

const MyWorkspaceRouter = () => {
  useRoles('my workspace');
  const { role } = useSelector((state) => state);
  // console.log(role);
  return (
    <Routes>
      {role.navChild.includes('my students') && <Route path="/my-students" element={<MyStudentsTable />} />}
      {role.navChild.includes('food') && <Route path="food" element={<FoodManagement />} />}
      <Route
        path="/*"
        element={
          <HrRoute>
            <HrRouter />
          </HrRoute>
        }
      />
      <Route
        path="/reporting_head_or_hod/*"
        element={
          <HodRoute>
            <HodRouter />
          </HodRoute>
        }
      />
      {/* <Route path="/cro-leads" element={<CroLeads />} /> */}
      <Route path="/cro-leads" element={<CroLeads2026 />} />
      <Route path="/cro-assessment-analytics" element={<CroAssessmentAnalytics />} />
      <Route path="/cro-leads-new" element={<CROleads />} />
      <Route path="/cro-lead-update" element={<UpdateLeadForm />} />
      <Route path="/cro-students" element={<CroStudentsView />} />
      <Route path="/cro-course-enroll" element={<CroCourseEnroll />} />
      <Route path="/cro-student-enroll/:cEid" element={<StudentErollForm />} />
      <Route path="/cro-fee-update" element={<UpdateTotalFee />} />
      <Route path="/cro-expected-sessions" element={<ExpectedSessions />} />
      <Route path="/cro-admission-register" element={<CroAdmissionRegister />} />
      <Route path="/crm-leads" element={<CrmLeads />} />
      <Route path="/crm-leads-new" element={<CRMLeadsNew />} />
      <Route path="/admission-register" element={<AdmissionRegister />} />
      <Route path="/generate-class-link" element={<GenerateClassLinkPage />} />
      <Route path="/random-session" element={<RandomSessionPage />} />
      <Route path="/update-expected-session" element={<UpdateExpectedSession />} />
      {/* income features for cros */}
      <Route path="/cro-income-view" element={<IncomePage />} />
      <Route path="/add-income" element={<AddIncome />} />
      <Route path="/cro-expense-view" element={<ExpensePage />} />
      <Route path="/cro-add-expense" element={<AddExpense />} />
      {/* income features for cros compleated */}
      <Route path="/cro-enquiries" element={<CroEnquiries />} />
      <Route path="/cro-enquiry-log" element={<CroEnquiryLog />} />
      <Route path="/subject-enrollment" element={<StudentEnrollment />} />
      <Route path="/cro-enquiries-foundation-pending" element={<CroEnquiriesFoundationProgramsPending />} />
      <Route path="/cro-enquiries-classroom-pending" element={<CroEnquiriesClassRoomProgramsPending />} />
      <Route path="/class-restart-dates" element={<StudentClassRestartDates />} />
      {/* <Route path="/inactive-students" element={<InactiveStudents />} /> */}
      <Route path="/trainer-details" element={<TrainerDetails />} />
      <Route path="/trainer-attendance-view" element={<TrainerAttendanceView />} />
      <Route path="/trainer-mou-details" element={<TrainerMoUDetails />} />
      <Route path="/trainer-payment-verification" element={<TrainerPaymentVerification />} />
      <Route path="/student-ledger" element={<MonthlyAccounts />} />
      <Route path="/ledger-view" element={<LedgerView />} />
      <Route path="/cro-income-forecast" element={<CROIncomeForecast />} />
      {/* <Route path="/payment-invoices" element={<PaymentInvoices />} /> */}
      <Route path="/payment-invoices" element={<InvoiceUpdatedPagination />} />
      {/* <Route path="/inactive-students-data-analytics" element={<InactiveStudentsDataAnalytics />} /> */}
      <Route path="/day-wise-sessions" element={<DayWiseSessions />} />
      <Route path="/crm-admission-close" element={<TerminationClearance />} />
      <Route path="/tc-uploaded-student-details" element={<TcUploadedStudentDetails />} />
      <Route path="/crm-income" element={<IncomeUpdatedPagination />} />
      {/* <Route path="/crm-income" element={<NewIncomePage />} /> */}
      {/* <Route path="/crm-income" element={<CrmIncome />} /> */}
      <Route path="/crm-expense" element={<CrmExpense />} />
      {/* ---------------SQA--Mytasks--------------------------------------- */}
      <Route path="/sqa-leads" element={<SqaLeads />} />
      <Route path="/study-materials" element={<StudyMaterials />} />
      {/* ---------------------------------------------------------------------------- */}
      {/* ---------------------------TA---Mytasks-------------------------------------- */}
      <Route path="/trainers-portal" element={<TrainersPortal />} />
      <Route path="/trainers-pan" element={<TrainerPan />} />
      <Route path="/trainers-for-cros" element={<TrainersForCros />} />
      <Route path="/trainer-payment" element={<TrainerPayment />} />
      {/* ---------------------------------------------------------------------------- */}
      <Route path="cro-student-evaluations" element={<CroEvaluations />} />
      <Route path="cro-student-session-analytics" element={<CroStudentSessionAnalytics />} />
      <Route path="cro-daily-no-attendance-students" element={<CroNotMarkedAttendance />} />
      <Route path="cro-term-fee-collection" element={<CroTermfeeCollection />} />
      <Route path="mobile-app-students" element={<MobileAppStudents />} />
      <Route path="invoice" element={<Invoice />} />
      <Route path="ta-trainer-evaluation" element={<TrainersEvaluation />} />
      <Route path="cr-Ledger-view" element={<CrLedgerView />} />
      <Route path="referral-admission-register" element={<ReferralAdmissionRegister />} />
      {/* --------------------research------------------------- */}
      <Route path="base-courses" element={<BaseCourses />} />
      <Route path="trainer-attendance" element={<TrainerAttendance />} />
      <Route path="enrollment-details" element={<EnrollmentDetails />} />
      <Route path="attendance-view" element={<AttendanceView />} />
      <Route path="cabin-settings" element={<CabinSettings />} />
      <Route path="slot-settings/:id" element={<SlotSettings />} />
      <Route path="dashboard" element={<DashBoard />} />
      <Route path="mentoring-request" element={<MentoringRequest />} />
      <Route path="wise-admin" element={<WiseAdmin />} />
      <Route path="student-enrollment" element={<Enrollment />} />
      <Route path="create-tutor" element={<CreateTutor />} />
      <Route path="assign-tutor" element={<AssignTutor />} />
      <Route path="department-employees-Details" element={<DepartmentEmployeesDetails />} />
      <Route path="digital-marketing-analytics" element={<DigitalMarketingAnalytics />} />
      <Route path="course-registration" element={<CourseRegistration />} />
      {/* -----------------------------------------smo------------------------------- */}
      <Route path="sme-leads" element={<SMEleads />} />
      <Route path="smo-leads" element={<SMOleads />} />
      <Route path="sme-topicschedules" element={<SMESchedules />} />
      {/* -------------------ogd---------------------------------- */}
      <Route path="ogm-leads" element={<OgmLeads />} />
      <Route path="oga-leads" element={<OgaLeads />} />
      <Route path="oga-expense" element={<OgaExpense />} />
      <Route path="reporting-head-comp-work-req" element={<ReportingHeadCompWorkReq />} />
      <Route path="ogd-admissonRegister" element={<AdmissionRegisterOgd />} />
      <Route path="edit-attendance/:id" element={<EditAttendance />} />
      <Route path="oga-wise-report" element={<OGAWiseReport />} />
      <Route path="lead-square-mapping" element={<LeadSquareMapping />} />
      <Route path="oga-reassignment" element={<AssignLeads />} />

      {/* -------------------crm---------------------------------- */}
      <Route path="inactive-cros" element={<InactiveCros />} />
      <Route path="cro-retention-leads" element={<RetentionLeads />} />

      {/* -------------------------------------permissions---------------------------------- */}
      <Route path="permissions" element={<Permissions />} />
      {/* --------------------------------uimodules------------------------------------ */}
      <Route path="uimodules" element={<Uimodule />} />
      {/* ---------------------------------------assessmentdashboard--------------------------- */}
      <Route path="assessment-dashboard" element={<AssessmentToolDashboard />} />
      <Route path="assessment-report" element={<AssessmentCourseView />} />
      <Route path="grade-wise-report" element={<AssessmentGrideWise />} />
      {/* --------------------------------------croreschedule------------------------------ */}
      <Route path="cro-reschedule" element={<CroReschedule />} />
      <Route path="session-preference" element={<SessionPreferences />} />
      <Route path="ta-reschedule" element={<TAReschedule />} />
      {/* ---------------------------------------srtdashboard------------------------------ */}
      <Route path="srt-croview" element={<Srtcroview />} />
      <Route path="srt-studentdetails" element={<SrtStudentDetailView />} />
      <Route path="srt-tastudentdetails" element={<SrtTastudentDetails />} />
      <Route path="srt-taview" element={<SrtTaView />} />
      {/* --------------------------------------trtdashboard--------------------------------- */}
      <Route path="trt-croview" element={<TrtCroview />} />
      <Route path="trt-studentdetails" element={<Trtstudentdetails />} />
      <Route path="trt-tawiseview" element={<TrtTaview />} />
      {/* -------------------------------cart--------------------------------- */}
      <Route path="cart" element={<Cart />} />
      <Route path="cart-skillx" element={<CartSkillx />} />
      <Route path="cart-leads" element={<CartLeads />} />
      <Route path="course" element={<Course />} />
      <Route path="studentTrack" element={<StudentTrack />} />
      <Route path="emi-course-payment" element={<EmiCoursePayment />} />
      {role.navChild.includes('evening food approval') && (
        <Route path="/evening-food-approval" element={<EveningFoodListApproval />} />
      )}

      {role.navChild.includes('Approve All Evening Food') && (
        <Route path="evening-food-approval-all-users" element={<EveningFoodApprovalForAll />} />
      )}
      <Route path="cart-edit-module" element={<ErrorCorrectionModule />} />
      {/* --------------------CRD------------------------- */}
      <Route path="/CRD-admission-register-crm-old" element={<NewAdmissionRegisterLanding crm={true} />} />
      <Route path="/CRD-admission-register-cro-old" element={<NewAdmissionRegisterLanding cro={true} />} />
      <Route path="/CRD-admission-register-pqa-old" element={<NewAdmissionRegisterLanding pqa={true} />} />
      <Route path="/CRD-admission-register-finance-old" element={<NewAdmissionRegisterLanding finance={true} />} />
      {/* --------------------CRD NEW ADMISSION REGISTER------------------------- */}
      <Route path="/CRD-admission-register-crm" element={<AdmissionRegisterCRD26 crm={true} />} />
      <Route path="/CRD-admission-register-cro" element={<AdmissionRegisterCRD26 cro={true} />} />
      <Route path="/CRD-admission-register-pqa" element={<AdmissionRegisterCRD26 pqa={true} />} />
      <Route path="/CRD-admission-register-finance" element={<AdmissionRegisterCRD26 finance={true} />} />
      {/* --------------------CRD END------------------------- */}
      <Route path="/cro-trainer-mapping" element={<CroTrainerMappingLanding />} />
      <Route path="assign-trainer" element={<AssignTrainer />} />
      <Route path="/attendance-mark" element={<MarkAttendance />} />
      <Route path="/student-attendance-view" element={<StudentAttendanceView />} />
      <Route path="/tutor-attendance-view" element={<TutorAttendanceView />} />
      <Route path="/ledger-view-cro" element={<LedgerViewCro />} />
      {/* <Route path="/monthly-accounts" element={<LedgerAccounts />} /> */}
      <Route path="/cart-edit" element={<CartEditView />} />
      <Route path="/batch" element={<Batchlanding />} />
      <Route path="/batch-assigned-tutor" element={<Assigntutor />} />
      <Route path="/crm-batch" element={<CrmBatchView />} />
      <Route path="/smo-batches" element={<SmoBatchLeads />} />
      <Route path="/sme-batches" element={<SMEbatchLeads />} />
      <Route path="/batch-reschedule" element={<BatchSessionReschedule />} />
      <Route path="/batch-attendance" element={<BatchAttendance />} />

      {role.navChild?.includes('CRM Assessment') && <Route path="/CRM-view" element={<CRMView />} />}

      {(role.navChild?.includes('CRM Assessment') || role.navChild?.includes('CRO Assessment')) && (
        <Route path="/CRO-view" element={<CROView />} />
      )}
      {/* ----------------------DEO------------------------- */}
      <Route path="deo-leads" element={<DeoLeadsView />} />
      <Route path="community" element={<IntervalCommunity />} />
      <Route path="webinar" element={<Webinar />} />
      <Route path="academic-calendar" element={<AcademicCalendarView />} />
      {role.navChild.includes('all users') && <Route path="all-users" element={<NewUser />} />}
      {/* People PHP has created that nobody has tagged yet. They carry
          employment_status = 0, which the All Users grid filters out, so without
          this screen they cannot be reached from anywhere. Gated on the same
          permission as All Users, so no new permission rows are needed. */}
      {role.navChild.includes('all users') && (
        <Route path="new-users" element={<NewJoinees />} />
      )}
      {/* New employee tagging screen, reached from the Edit button on the all users
          table. Replaces /my-workspace/editemployee/:id, which is still routed in
          HrRouter and still works, it is simply no longer linked to. */}
      {role.navChild.includes('all users') && (
        <Route path="employee-tagging/:id" element={<EmployeeTagging />} />
      )}
      {/* Read only history, opened in a new tab from the Show History button */}
      {role.navChild.includes('all users') && (
        <Route path="employee-history/:id" element={<EmployeeHistory />} />
      )}
      {/* The managed list of change types behind the history timeline */}
      {role.navChild.includes('all users') && (
        <Route path="employment-change-types" element={<EmploymentChangeTypes />} />
      )}
      {/* ------------------------------finance------------------------------------------ */}

      <Route path="/fee-forcasting" element={<FeeForcasting />} />

      <Route path="/asset-dashboard" element={<AssetDashboard />} />
      <Route path="/course-options" element={<CourseOption />} />
      <Route path="/transport-verification" element={<TransportVerification />} />
      {/* --------------------------------------------muei--------------------------------------------- */}
      <Route path="/muei-dashboard" element={<MUEIDashboard />} />
      <Route path="/admission-batch-register" element={<BatchAdmissionRegisterLanding />} />
      <Route path="/student-attendance" element={<StudentAttendanceLanding />} />
      <Route path="/batch-academic-calendar" element={<BatchCalendarLanding />} />
      <Route path="/qr-codes" element={<QrCode />} />
      {/* --------------------------------------- leave grant --------------------------------------------------- */}
      <Route path="hod-leave-grant-requests" element={<LeaveGrantRequest />} />
      {role.navChild.includes('wfh grant approval') && (
        <Route path="hr-leave-grant-requests" element={<HrLeaveGrantRequest />} />
      )}
      <Route path="form-builder" element={<FormBuilder />} />
      <Route path="food-scanner" element={<FormBuilder scanner={true} />} />
      <Route path="skillx-deo-leads" element={<SkillxDeoLeads />} />

      {/* ---------------------------------------- Refund Request --------------------------------------------- */}
      <Route path="refund-request" element={<RefundRequest />} />
      <Route path="duplicate-requests" element={<DuplicateRequests />} />
      <Route path="re-request" element={<RerequestData />} />

      {/* ---------------------------------------- find my tutor --------------------------------------------- */}
      <Route path="find-my-tutor" element={<FindMyTutorLanding />} />
      {/* Attendance Regularizations*/}
      {role.navChild.includes('department regularization') && (
        <Route path="attendance-regularization" element={<AttendanceRegularization head={'Team Head'} />} />
      )}
      {/* -----------------------config-------------------------- */}
      <Route path="config" element={<Config />} />
      <Route path="refund-request-pm" element={<RefundRequestPM />} />
      <Route path="new-refund-request" element={<NewRefundRequest />} />
      <Route path="refund-request-finance" element={<RefundRequestFinance finance={true} />} />
      <Route path="scheduled-refund-payments" element={<ScheduledPayments />} />
      {/* ---------------------------------------- Student Edit --------------------------------------------- */}
      <Route path="student-edit/:id" element={<StudentEditLanding />} />

      {/* ---------------------------------------- refund --------------------------------------------- */}
      <Route path="refund-approval" element={<VerifyApprove />} />
      <Route path="refund-verification" element={<VerifyApprove verify />} />
      <Route path="refund-deduction" element={<RefundDeduction />} />
      <Route path="refundTrack" element={<RefundTrack />} />

      {/* ---------------------------------------- Calendar Edit --------------------------------------------- */}

      <Route path="academic-calendar-edit" element={<CalendarEdit />} />
      <Route path="admin-hr-policy" element={<AdminHrPolicy />} />
      {/* ---------------------------------------------- c s w --------------------------------------------------- */}
      <Route path="course-view" element={<CourseView />} />
      <Route path="project-details" element={<ProjectCourses />} />
      {/* <Route path="course-creation" element={<CourseCreationPage />} /> */}
      <Route path="course-view/:id" element={<CoursePreview />} />
      {/* ---------------------------------------- Assessment Details --------------------------------------------- */}
      <Route path="assessment-details" element={<AssessmentDetails />} />

      {/* ---------------------------------------- Calendar Edit Batch  --------------------------------------------- */}

      <Route path="batch-calendar-edit/:id" element={<BatchCalenderEdit />} />

      {/* ----------------------------------------lens-wise--------------------------------------------------------- */}
      <Route path="student-lens-sync" element={<StudentSync />} />
      {/* ---------------------------------------- Placement Tracker --------------------------------------------- */}
      <Route path="placement-tracker" element={<PlacementTrackerTable />} />

      {/* ---------------------------------------- CRD Migration Starts --------------------------------------------- */}
      <Route path="inactive-students-data-analytics" element={<InactiveStudentDataAnalytcs />} />
      <Route
        path="cro-inactive-students-data-analytics-navigate"
        element={<InactiveStudentDataAnalyticsNavigation />}
      />
      <Route path="student-session-analytics" element={<StudentSessionAnalytics />} />
      <Route path="tc-upload-student-details" element={<TcUploadStudentDetails />} />
      <Route path="tp-verification" element={<TpVerificationNavigation />} />
      <Route path="cro-expense-new" element={<Expense CRO />} />
      <Route path="expense-new" element={<Expense />} />
      <Route path="course-income" element={<CourseIncome />} />
      <Route path="fee-transfer" element={<FeeTransferNavigation />} />
      <Route path="crd-expense" element={<ExpenseNavigation />} />
      <Route path="income-forcaste" element={<IncomeForecaseNavigation />} />
      <Route path="cro-individual-accounts" element={<CroIndividualAccounts />} />
      <Route path="expiring-admission" element={<ExpiringAdmission />} />
      <Route path="cro-expiring-admission" element={<CroExpiringAdmission />} />
      <Route path="department-employees" element={<DepartmentEmployees />} />
      <Route path="student-class-restart-date" element={<StudentClassRestartDate />} />
      <Route path="classroom-evaluations" element={<ClassRoomEvaluationNavigation />} />
      <Route path="batch-tp-verification" element={<BatchTpVerificationNavigation />} />
      <Route path="term-fee-collection" element={<TermFeeCollectionNavigation />} />
      <Route path="student-journey" element={<StudentJourneyNavigation />} />
      <Route path="monthly-accounts" element={<CroIndividualAccounts croView={true} />} />
      <Route path="daily-no-attendance" element={<DailyNoAttendanceStudentsLanding />} />
      <Route path="trainer-mou" element={<TrainerMOU />} />
      <Route path="attendance-view-cro" element={<AttendanceViewCro />} />
      <Route path="emi-payments" element={<EmiPaymentsLanding />} />
      <Route path="tutor-search" element={<TutorSearchNavigation />} />
      <Route path="course-attendance-type-module" element={<CourseAttendanceTypeModuleNavigation />} />
      <Route path="non-scheduled-session-verification" element={<NonScheduledSessionVerification />} />
      <Route path="tutor-replacements" element={<TutorReplacements />} />
      <Route path="tutor-replacement-tracker" element={<TutorReplacementTracker />} />
      <Route path="tutor-replacement-ta-head" element={<TaHeadReplacements />} />
      <Route path="tutor-replacement-ta-associate" element={<TaAssociateReplacements />} />
      <Route path="tutor-replacement-cro" element={<CroReplacements />} />
      {/* ---------------------------------------- CRD Migration End --------------------------------------------- */}
      <Route path="tutor-cards" element={<FindMyTutorCardsLanding />} />

      {/* --------------------------fe-forecast-latest----------------------------------------------------------------- */}
      <Route path="/fee-forecast-register" element={<FeeForecastRegister />} />
      <Route path="/fee-forecast" element={<FeeForecastLatest />} />
      <Route path="prospect-leads" element={<ProspectLeads />} />

      {/* --------------------------- OGD CSD EXTRA ---------------------------------------------------------------- */}
      <Route path="add-bonus-csv" element={<AddExtraForLeadExpense pageType={'bonus'} />} />
      <Route path="add-salary-csv" element={<AddExtraForLeadExpense pageType={'salary'} />} />
      <Route path="add-campaign-csv" element={<AddExtraForLeadExpense pageType={'campaign'} />} />
      <Route path="lsq-leads" element={<LsqLeads />} />
      {/* ------------------------------- STUDENT PORTAL -------------------------------------------- */}
      <Route path="course-purchase-requests" element={<CoursePurchaseRequest />} />
      <Route path="student-portal-leads" element={<StudentPortalLeads />} />
      {/* ------------------------------- SKILLX -------------------------------------------- */}
      {/* The learner roster, and the one column it owns: student.skillx_id.
          A SkillX student is one enrolled on a SkillX-project course. */}
      <Route path="skillx-students" element={<SkillxStudents />} />
      {/* The CRO's month grid: one row per learner, one column per day.
          Read only — class days are owned by the batch calendar screens. */}
      <Route path="skillx-attendance" element={<SkillxAttendanceRegister />} />
      <Route path="skillx-assignments" element={<SkillxAssignments />} />
      <Route path="skillx-batch-leaderboard" element={<SkillxBatchLeaderBoard />} />
      {/* XP: the admin's point table, and the mentor's hand-awards + audit. */}
      <Route path="skillx-xp-settings" element={<SkillxXpSettings />} />
      <Route path="skillx-xp-awards" element={<SkillxXpAwards />} />
      

      {/* Common badges (tier 2), awarded by hand. Module badges are earned by
          approving the project in the assignments area, so they have no page. */}
      <Route path="skillx-recognition-badges" element={<SkillxCommonBadges />} />
      {/* Sales view of what SkillX learners have referred. Read-only — the rows
          are created by the Student Portal and worked through the lead screens. */}
      <Route path="skillx-referral-leads" element={<SkillxReferralLeads />} />
      {/* Learners' admission-detail verification, and the CRO's "mark verified".
          Gated on the permission title; permissions.path must be
          /my-workspace/skillx-admission-verification. */}
      {role.navChild.includes(SKILLX_ADMISSION_VERIFICATION_PERMISSION) && (
        <Route path="skillx-admission-verification" element={<SkillxAdmissionVerification />} />
      )}
      {/* ------------------------- PARENT LANDING CMS ------------------------ */}
      {/* The question banks behind the public assessment at
          /auth/parent-landing: the Class 1-4 subject papers, the KG picture
          paper, and the questionnaire every parent answers first. Editing here
          changes the live funnel with no deploy. */}
      <Route path="assessment-question-bank" element={<AssessmentQuestionBank />} />
      {/* Copy, imagery, meta tags, structured data and the GTM slot for the
          same public page. Meta is server-rendered via ISR, so an edit reaches
          crawlers within the revalidation window. */}
      <Route path="landing-page-cms" element={<LandingPageCms />} />
      {/* -----------------------for MEL-------------------------------------------- */}
      {role.navChild.includes('leave analytics mel') && (
        <Route path="leave-analytics-mel" element={<LeaveAnalyticsNew />} />
      )}

      <Route path="/unassigned-batch-leads-cro" element={<UnAssignedBatchLeadsLanding cro={true} />} />

      <Route path="/unassigned-batch-leads-crm" element={<UnAssignedBatchLeadsLanding crm={true} />} />

      {/* Employee Engagement (Triblast) — SSO launcher */}
      <Route path="engagement" element={<EngagementLanding />} />

      {/* Achievement Badges — CRUD */}
      <Route path="achievement-badges" element={<AchievementBadges />} />

      {/* Milestone Achievements */}
      <Route path="milestone-achievements" element={<MilestoneAchievements />} />

      {/* Data Access Console launcher — the sidebar entry itself is granted by the
          backend menu, which is also what gates the navbar button. */}
      <Route path="data-access" element={<DataAccessLanding />} />

      {/* Department Income Tracker — company-wide daily income collection + TAR per
          department, computed straight from `income`. See
          docs/department_income_tar_tracking.md in node-portal-from-29-08-2022. */}
      <Route path="department-income-tracker" element={<DepartmentIncomeTrackerLanding />} />

      {/* Set CRO Targets — who you can set a target for is enforced server-side: Finance
          sees/sets anyone, everyone else only their own active reports. */}
      <Route path="set-cro-targets" element={<SetCroTargetsLanding />} />

      {/* Incentive Challenges — Finance's CRUD over the targets staff are measured
          against. Named specifically because other kinds of challenge are expected
          later and "challenges" would not stay unambiguous.

          'Incentive Challenges' is the `permissions.title` row, and the route
          segment has to match `permissions.path` exactly or the sidebar 404s. */}
      {role.navChild.includes('Incentive Challenges') && (
        <Route path="incentive-challenges" element={<IncentiveChallengeList />} />
      )}
    </Routes>
  );
};

export default MyWorkspaceRouter;
